var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000009554306048466658990000005134600268171090087_);}\n\t.st1{fill:#EAEAEA;}\n\t.st2{fill:#D2D2D2;}\n\t.st3{fill:#9C9C9C;}\n\t.st4{fill:#ABABAB;}\n\t.st5{fill:#BFBFBF;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 30,
    height: 30
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035509008349769578660000017484621592557008033_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "currentColor",
    d: "M14.9,0.1l13.8,8.7c0.3,0.2,0.4,0.7,0.2,1c-0.1,0.2-0.4,0.3-0.6,0.3H0.7C0.3,10.2,0,9.8,0,9.4 C0,9.2,0.1,9,0.3,8.8l13.8-8.7C14.4,0,14.7,0,14.9,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "currentColor",
    d: "M14.5,1.8L4,8.5h21.1L14.5,1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "currentColor",
    d: "M15.1,5h-1.2c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8h1.2c0.5,0,0.8-0.4,0.8-0.8C16,5.4,15.6,5,15.1,5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "currentColor",
    d: "M6.5,13.5H3.2V25h3.3V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "currentColor",
    d: "M13,13.5H9.6V25H13V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "currentColor",
    d: "M19.4,13.5h-3.3V25h3.3V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "currentColor",
    d: "M25.8,13.5h-3.3V25h3.3V13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    fill: "currentColor",
    d: "M27,10.2H2v3.3h25V10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "currentColor",
    d: "M28.3,25H0.7C0.3,25,0,25.4,0,25.8v2.5C0,28.7,0.3,29,0.7,29h27.6c0.4,0,0.7-0.3,0.7-0.7v-2.5 C29,25.4,28.7,25,28.3,25z"
  })))));
};
export default SvgBank;